import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { getMybootcampPaymentsAction } from "../../../actions/BootCamp/bootcampActions";

const CustomDrawer = ({
  isSidebarOpen,
  setIsSidebarOpen,
  activeView,
  setActiveView,
}) => {
  const menuItems = [
    "bootcamps",
    "certificates",
    "portfolio",
    "badges",
    "payments",
    "profile",
    "support",
  ];

  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="left"
      open={isSidebarOpen}
      onClose={() => setIsSidebarOpen(false)}
      PaperProps={{
        sx: {
          width: 260,
          top: "60px",
          height: "calc(100vh - 60px)",
          backdropFilter: "blur(18px) saturate(116%)",
          WebkitBackdropFilter: "blur(18px) saturate(116%)",
          backgroundColor: "rgba(246, 253, 255, 0.05)",
          border: "1px solid rgba(255, 255, 255, 0.125)",
          borderLeft: "none",
          padding: "20px",
        },
      }}
      BackdropProps={{
        sx: {
          top: "60px",
        },
      }}
    >
      {/* Header with close button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2.5,
        }}
      >
        <IconButton
          onClick={() => setIsSidebarOpen(false)}
          sx={{
            color: "#d6deeb",
            fontSize: "24px",
            p: 0,
            minWidth: "auto",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          ×
        </IconButton>
      </Box>

      {/* Navigation items */}
      <List sx={{ p: 0 }}>
        {menuItems.map((view) => (
          <ListItem key={view} sx={{ p: 0, mb: "5px" }}>
            <ListItemButton
              onClick={() => {
                if (view === "payments") {
                  dispatch(getMybootcampPaymentsAction());
                }
                setActiveView(view);
                setIsSidebarOpen(false);
              }}
              sx={{
                padding: "10px 15px",
                color: "#d6deeb",
                backgroundColor:
                  activeView === view ? "#fbbf24" : "transparent",
                borderRadius: "6px",
                transition: "all 0.3s",
                "&:hover": {
                  backgroundColor: "#fbbf24",
                  color: "#ffffff",
                },
                ...(activeView === view && {
                  color: "black",
                }),
              }}
            >
              <ListItemText
                primary={view.charAt(0).toUpperCase() + view.slice(1)}
                primaryTypographyProps={{
                  sx: { fontWeight: "inherit" },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default CustomDrawer;
